moduleParallax = angular.module('parallax.initializer', [])

moduleParallax.service 'Parallax', ["$timeout", "$injector", "ns", ($timeout, $injector, ns) ->
  'use strict'
  Y = undefined

  parallax =
    init: (y) ->
      Y = y
      @initSections()
    findSections: ->
      Y.all(ns.sectionClass)
    initSection: (element) ->
      jElement = $(element._node)
      sectionJson = element.section
      sectionId = sectionJson.id
      parallaxNeed = sectionJson.background_attributes.parallax
      speed = sectionJson.background_attributes.parallax_speed
      return false if !parallaxNeed
      $(window).unbind "scroll.parallax.#{sectionId}"
      $(window).bind "scroll.parallax.#{sectionId}", ->
        sectionTop = jElement.offset().top - $(window).height()
        scrollTop = $(window).scrollTop()
        scrollTopBg = jElement.offset().top - scrollTop
        if scrollTop > sectionTop
          k = 10 - (speed-1)/10
          yPos = -(scrollTopBg / k)
          coords = 'center '+ yPos + 'px'
          jElement.css backgroundPosition: coords
        else
          jElement.css backgroundPosition: ""
    destroy: (section) ->
      id = section.section.id
      $(window).unbind "scroll.parallax.#{id}"
      section.setStyles {backgroundPosition: ""}
    initSections: ->
      @findSections().each @initSection
  parallax
]



// WEBPACK FOOTER //
// ./src/app/editor/section_initializers/parallax/parallax.initializer.coffee